import { useMemo } from 'react'
import { getUserPermissions, PlatformPermission } from './rbac'
import { ENV_MODES } from '@/utils/constants'

export function usePermissions(appRole: string | string[] | undefined) {
  const mode = import.meta.env.MODE

  const userPermissions = useMemo(() => {
    // appRole may be undefined / null / empty (claim missing from token, user
    // not yet loaded, etc.). getUserPermissions handles this by returning the
    // DEFAULT_PERMISSIONS baseline (currently [ViewUser])
    return getUserPermissions(appRole)
  }, [appRole])

  // Bypass RBAC in development and staging for easier testing and support
  const bypass = mode === ENV_MODES.DEVELOPMENT || mode === ENV_MODES.STAGING

  const hasPermission = (permission: PlatformPermission) => {
    if (bypass) return true
    //Platform perm. admin OR support should have all permissions by default
    if (
      userPermissions.includes(PlatformPermission.Admin) ||
      userPermissions.includes(PlatformPermission.Support)
    ) {
      return true
    }
    return userPermissions.includes(permission)
  }

  // Strict: hasPermission lets Support stand in for Admin, which is wrong for admin-only actions.
  const isAdmin = () => bypass || userPermissions.includes(PlatformPermission.Admin)

  return {
    hasPermission,
    isAdmin,
  }
}
